/**
 * Author：brand
 * Creation Time：2019-08-28 16:03
 * Email：brandhuang@qq.com
 */
import * as utils from '@/utils/utils'
import ReconnectableWebSocket from './ReconnectableWebSocket'

let WSC_URL = process.env.VUE_APP_WSC_URL

export function initWebSocket (param) {
  let chatsData = param.chats // 会话数据
  let messagesHistory = ''
  let messagesId = ''
  for (let i in chatsData) {
    messagesHistory = chatsData[i].messages_history
    messagesId = chatsData[i].messages_id
  }

  // 标记是否因服务端主动close/blackclose而关闭 (不应重连)
  let serverClosed = false

  const rws = new ReconnectableWebSocket({
    url: WSC_URL + '?from_uid=' + param.client_uid,
    pingTimeout: 45000,
    // chat_web 的 pong 需要携带最后一条消息的 role 和 sendtime
    buildPongMessage: () => {
      let tmpMsgs = window.vm.$store.state.messages
      let lastMsg = tmpMsgs[tmpMsgs.length - 1]
      return {
        pong: {
          message: {
            type: 'pong',
            role: lastMsg ? lastMsg.role : '',
            sendtime: lastMsg ? lastMsg.sendtime : ''
          }
        }
      }
    },
    // 重连后重发 clientlogin（使用最新消息状态，让服务端返回断线期间遗漏的消息）
    buildLoginMessage: () => {
      let latestHistory = messagesHistory
      let latestMsgId = messagesId
      // 从 store 获取最新的消息列表，提取最后一条消息的 id 供服务端判断增量
      let tmpMsgs = window.vm.$store.state.messages
      if (tmpMsgs && tmpMsgs.length > 0) {
        let lastMsg = tmpMsgs[tmpMsgs.length - 1]
        if (lastMsg && lastMsg.messages_id) {
          latestMsgId = lastMsg.messages_id
        }
        latestHistory = '1'
      }
      return {
        clientlogin: {
          message: {
            type: 'clientlogin',
            role: 'client',
            agent_uid: param.agent_uid,
            company_id: param.company_id,
            r_id: param.r_id,
            client_uid: param.client_uid,
            client_nickname: param.client_nickname,
            calling_no: param.calling_no,
            messages_history: latestHistory,
            messages_id: latestMsgId,
            consult: param.consult,
            consultLink: param.consultLink
          }
        }
      }
    }
  })

  // 连接成功回调 (clientlogin 由 buildLoginMessage 统一发送，首次和重连都走同一路径)
  rws.onOpen = () => {
    console.log('ws 连接成功')
  }

  // 接收到websocket推送 (ping已由ReconnectableWebSocket自动回复pong)
  rws.onMessage = (resData, rawEvent) => {
    if (!resData) return
    switch (resData.type) {
      // ping已自动处理，忽略
      case 'ping':
        break
      // 登录
      case 'login':
        for (let uid in resData.data.chats) {
          let loginChatMsg = resData.data.chats[uid]
          if (loginChatMsg.messages.length > 0) {
            loginChatMsg.messages.map(item => {
              window.vm.$store.dispatch('_updateMsg', item)
            })
          }
          window.vm.$store.dispatch('_loginSuccess', new Date())
        }
        break
      //  收发消息
      case 'say':
        for (let uid in resData.data) {
          let sayChatMsg
          if (resData.status === 3) { // status为3，转接人工时客服不在线，跳转留言
            sayChatMsg = {
              'sendtime': resData.data[uid].sendtime,
              'role': 'event',
              'text': resData.data[uid].text + '<span class="manual " style="color: #3396fb;padding-left: 5px;cursor: pointer;font-size: 13px"><span class="js_to_leaveMsg">去留言</span></span>'
            }
          } else if (resData.status === 2) { // status为2时，需要转接人工
            if (resData.is_manual_switch === 0) { // 自动转人工
              sayChatMsg = {
                'type': 'say',
                'sendtime': resData.data[uid].sendtime,
                'agent_avatar': resData.data[uid].agent_avatar,
                'agent_nickname': resData.data[uid].agent_nickname,
                'role': 'agent',
                'msg_type': 'text',
                'text': resData.data[uid].text
              }
              // 触发自动转人工
              window.vm.$store.dispatch('_autoTurnManual', new Date().getTime())
            } else if (resData.is_manual_switch === 1) { // 手动转人工
              sayChatMsg = {
                'type': 'say',
                'sendtime': resData.data[uid].sendtime,
                'agent_avatar': resData.data[uid].agent_avatar,
                'agent_nickname': resData.data[uid].agent_nickname,
                'role': 'agent',
                'msg_type': 'text',
                'text': resData.data[uid].text + `<span class="manual "><span class="js_manual">转人工</span></span>`
              }
            }
          } else {
            if (resData.isSystemMsg === 0) { // 0是机器人回复消息
              let text = resData.data[uid].text
              let relateProblems = resData.relateProblems
              let div = document.createElement('div')
              let ul = document.createElement('div')
              if(relateProblems.length){
                let p = document.createElement('p')
                p.innerHTML = resData.problemGuideText || ''
                p.setAttribute('class', 'problem-tips')
                p.style.marginTop = "8px"
                div.appendChild(p)
              }
              div.setAttribute('class', 'problem-container')
              ul.setAttribute('class', 'problem-list')
              for (let i = 0; i < relateProblems.length; i++) {
                let li = document.createElement('div')
                li.setAttribute('class', 'problem-item j-send-problem')
                li.innerHTML = relateProblems[i].standardProblem
                ul.appendChild(li)
              }
              div.appendChild(ul)
              let tmpNode = document.createElement('div')
              tmpNode.appendChild(div)
              let str = tmpNode.innerHTML
              str = text + str
              tmpNode = div = null // 解除引用，以便于垃圾回收
              sayChatMsg = {
                'type': 'say',
                'sendtime': resData.data[uid].sendtime,
                'agent_avatar': resData.data[uid].agent_avatar,
                'agent_nickname': resData.data[uid].agent_nickname,
                'role': 'agent',
                'msg_type': 'text',
                'to_uid': resData.data[uid].to_uid,
                'msg_status': '1',
                'callingId': resData.data[uid].callingId,
                'isSysMsg': 'notSysMsg',
                'text': str,
                'handler': '<p class=\'js_settled\' data-callingId=\'' + resData.data[uid].callingId + '\' data-visitId=\'' + resData.data[uid].to_uid + '\'>已解决</p><p' +
                  ' class=\'js_no_settled\' data-callingId=\'' + resData.data[uid].callingId + '\' data-visitId=\'' + resData.data[uid].to_uid + '\'>未解决</p>'
              }
            } else if (resData.isSystemMsg === 1) { // 1是系统消息
              sayChatMsg = {
                'type': 'say',
                'sendtime': resData.data[uid].sendtime,
                'agent_avatar': resData.data[uid].agent_avatar,
                'agent_nickname': resData.data[uid].agent_nickname,
                'role': 'agent',
                'msg_type': 'text',
                'text': resData.data[uid].text
              }
            } else { // 正常的消息
              sayChatMsg = resData.data[uid]
            }
          }
          rws.send({
            'sayback': {
              'message': {
                'from_uid': resData.data[uid].from_uid,
                'role': 'client',
                'to_uid': resData.data[uid].to_uid,
                'callingId': resData.data[uid].callingId || ''
              }
            }
          })
          // resData.data[uid].callingId?sayChatMsg.callingId = resData.data[uid].callingId : ''
          sayChatMsg.libType = resData.libType
          window.vm.$store.dispatch('_updateMsg', sayChatMsg)
          window.vm.$store.dispatch('_sayMsg', new Date().getTime())
        }
        break
      // 消息撤回
      case 'revoke':
        for (let uid in resData.data) {
          let revokeChatMsg = resData.data[uid]
          // let chatMessages =  window.vm.$store.state.messages
          window.vm.$store.dispatch('_revokeMsg', revokeChatMsg)
        }
        break
      // 客服转接
      case 'switching':
        for (let uid in resData.data) {
          let switchingMsg = resData.data[uid]
          switchingMsg.text = switchingMsg.text.replace(/<[^>]+>/g, '').replace(/&nbsp;/ig, '')
          window.vm.$store.dispatch('_switchingMsg', switchingMsg)
          window.vm.$store.dispatch('_updateMsg', switchingMsg)
          window.vm.$store.dispatch('_sayMsg', new Date().getTime())
        }
        break
      // 会话关闭 → 主动关闭，不重连
      case 'close':
        for (let uid in resData.data) {
          let closeChatMsg = resData.data[uid]
          if (closeChatMsg.text && closeChatMsg.text.trim().length > 0) {
            window.vm.$store.dispatch('_updateMsg', closeChatMsg)
          }
          window.vm.$store.dispatch('_chatClose', true)
        }
        serverClosed = true
        rws.close()
        break
      // 评价邀请
      case 'inviteEvaluation':
        window.vm.$store.dispatch('_inviteEvaluation', resData)
        break
      // 加入黑名单 → 主动关闭，不重连
      case 'blackclose':
        window.vm.$store.dispatch('_blackClose', true)
        serverClosed = true
        rws.close()
        break
      // 客服退出 → 重新初始化ws
      case 'agentlogout':
        for (let agentUid in resData.data) {
          param.agent_uid = agentUid
        }
        serverClosed = true
        rws.close()
        setTimeout(function () {
          initWebSocket(param)
        }, 100)
        break
      // 常用问题
      case 'commomProblem':
        let commomProblem = resData.data
        let div = document.createElement('div')
        let ul = document.createElement('div')
        let p = document.createElement('p')
        p.innerHTML = '你可能想问以下问题：'
        p.setAttribute('class', 'problem-tips')
        div.appendChild(p)
        div.setAttribute('class', 'problem-container')
        ul.setAttribute('class', 'problem-list')
        for (let i = 0; i < commomProblem.length; i++) {
          let li = document.createElement('div')
          li.setAttribute('class', 'problem-item j-send-problem')
          li.innerHTML = commomProblem[i].standardProblem
          ul.appendChild(li)
        }
        div.appendChild(ul)
        let tmpNode = document.createElement('div')
        tmpNode.appendChild(div)
        let str = tmpNode.innerHTML
        tmpNode = div = null // 解除引用，以便于垃圾回收
        let commomProblemMsg = {
          'type': 'say',
          'sendtime': resData.sendtime,
          'agent_avatar': resData.agent_avatar,
          'agent_nickname': resData.agent_nickname,
          'role': 'agent',
          'msg_type': 'text',
          'msg_status': '1',
          'isSysMsg': 'notSysMsg',
          'text': str
        }
        window.vm.$store.dispatch('_updateMsg', commomProblemMsg)
        break
      // 更新排队数量
      case 'updateQueueNum':
        window.vm.$store.dispatch('_updateQueuueNum',resData.data.frontNum)
        break
      // 排队结束
      case 'waitend':
        let params = {
          cid: window.vm.$cookie.get('cid'),
          uniquecode: window.vm.$cookie.get('FENBOT_fingerprint'),
          toid: window.vm.$utils.GetQueryString('toid'),
          csid: window.vm.$utils.GetQueryString('csid'),
          uid: window.vm.$utils.GetQueryString('uid'),
          type: window.vm.$utils.GetQueryString('type'),
          source: window.vm.$utils.GetQueryString('source')
        }
        serverClosed = true
        rws.close()
        eventBus.$emit('waitend')
        window.vm.$store.dispatch('_login', params, resData.data.clientId)
        break
      // 已读未读
      case 'haveReadUnread':
        console.log(resData)
        break
    }
  }

  rws.onClose = () => {
    if (serverClosed) {
      console.log('[chat_web] 会话已正常结束')
    }
  }

  rws.onReconnected = () => {
    console.log('[chat_web] 重连成功，调用 loginAPI 刷新消息')
    // 延迟等待 WS login 响应处理完毕
    setTimeout(function () {
      var loginParams = {
        cid: window.vm.$cookie.get('cid') || window.vm.$utils.GetQueryString('cid'),
        uniquecode: window.vm.$cookie.get('FENBOT_fingerprint'),
        toid: window.vm.$utils.GetQueryString('toid'),
        csid: window.vm.$utils.GetQueryString('csid'),
        uid: window.vm.$utils.GetQueryString('uid'),
        type: window.vm.$utils.GetQueryString('type'),
        source: window.vm.$utils.GetQueryString('source')
      }
      console.log('[chat_web] loginAPI 参数:', loginParams)
      window.vm.$http.loginAPI(loginParams).then(function (res) {
        console.log('[chat_web] loginAPI 响应:', res)
        if (res.status === '1' && res.data && res.data.chats) {
          // 清空旧消息，用最新消息替换（与页面刷新效果一致）
          window.vm.$store.commit('RESET_MSG')
          window.vm.$store.commit('SET_LOGIN_INFO', res.data)
          for (var uid in res.data.chats) {
            var msgs = res.data.chats[uid].messages || []
            for (var i = 0; i < msgs.length; i++) {
              window.vm.$store.commit('UPDATE_MSG', msgs[i])
            }
          }
          console.log('[chat_web] loginAPI 刷新完成，用户可点"查看更多历史消息"加载更多')
        }
      }).catch(function (err) {
        console.warn('[chat_web] loginAPI 调用失败:', err)
      })
    }, 2000)
  }

  rws.onReconnecting = (attempt, max) => {
    console.log('[chat_web] 重连中 (' + attempt + '/' + max + ')')
  }

  rws.onReconnectFailed = () => {
    console.error('[chat_web] 重连失败')
  }

  rws.bindNetworkEvents()
  rws.connect()
  return rws
}
